export const listData = [
	{
		title: "made by eom / fabricación Equipo Original",
		subtitle: "Somos el reemplazo ideal de las pastillas de freno originales de tu auto",
	},
	{
		title: "braking tests / pruebas vehiculares",
		subtitle: "Validamos todos nuestros productos en condiciones reales",
	},
	{
		title: "Ece r90 certification / certificación ece r90",
		subtitle: "Diseño, fabricación y desempeño EO",
	},
	{
		title: "Hardware included / herrajes incluidos",
		subtitle: "Incluye las piezas necesarias para un cambio de frenos profesional",
	},
	{
		title: "100% copper-free / 100% libres de cobre",
		subtitle: "Pastillas de frenos amigables con el medio ambiente",
	},
	{
		title: "Formula oe for each vehicle / fórmulas específicas",
		subtitle: "Cada auto, una fórmula de Pastillas que garantiza seguridad",
	},
	{
		title: "Braking safety / seguridad de frenado",
		subtitle: "Familias y Personas seguras en cualquier condición de uso",
	},
];
